<button
  type="button"
  class="ai-generate-btn"
  [disabled]="disabled || loading"
  [attr.aria-busy]="loading"
  (click)="onClick()"
>
  @if (loading) {
    <span class="ai-spinner" aria-hidden="true"></span>
    <span class="ai-text">Generating…</span>
  } @else {
    <img src="assets/AI.svg" alt="" class="ai-icon" />
    <span class="ai-text">Generate</span>
  }
</button>
